// First Impression (Venus): a word that begins with a vowel scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { isVowel, lettersOf } from '../shared/letters';
import type { AlignmentDef } from '../types';

export const firstImpression: AlignmentDef = {
  id: 'first-impression',
  planet: 'venus',
  name: 'First Impression',
  text: () => `Words that begin with a vowel score +${N.firstImpressionPercent}%.`,
  wordPercent: (c) => (isVowel(lettersOf(c.word)[0] ?? '') ? N.firstImpressionPercent : 0),
};
